module.exports = __webpack_public_path__ + "media/images/athletes/3391-d0d81377ece09a50b6382cb05076bb07.png";